import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@material-ui/core/Button';

import { store } from '~/store';
import { closeNotification } from '~/store/modules/notification/actions';

import ReleaseNotificacao from '../../componentsLocal/Notificacoes/Release';
import CustomizedDialogs from '../../componentsLocal/UnidataDialog';
import { Gas, History } from './components';
import { Container } from './styles';

export default function Dashboard() {
  // const dispatch = useDispatch();

  // const { profile } = store.getState().user;
  // const { opened } = useSelector((state) => state.notification);

  // const closeModal = () => {
  //   dispatch(closeNotification(false));
  // };

  return (
    <>
      <Container>
        <div className="row abastecimento">
          <Gas />
          <History />
        </div>
      </Container>

      {/* ({JSON.stringify(process.env.REACT_APP_TAG !== profile.versao && opened)})
      ({JSON.stringify(process.env.REACT_APP_TAG)})
      ({JSON.stringify(profile.versao)})
      ({JSON.stringify(profile)})
      ({JSON.stringify(opened)}) */}

      {/* <CustomizedDialogs
        open={process.env.REACT_APP_TAG !== profile.versao && opened}
        handleClose={closeModal}
        title={`Lançada nova versão ${process.env.REACT_APP_TAG}`}
        children={<ReleaseNotificacao />}
        actions={
          <>
            <Button
              variant="contained"
              color="primary"
              onClick={() => {
                window.open('/changesrelease', '_blank');
                closeModal();
              }}
            >
              Sim
            </Button>
            <Button
              variant="contained"
              color="secondary"
              onClick={() => {
                closeModal();
              }}
            >
              Não
            </Button>
          </>
        }
      /> */}
    </>
  );
}
